import { render, staticRenderFns } from "./MeasureCard.vue?vue&type=template&id=13b2205d&scoped=true&"
import script from "./MeasureCard.vue?vue&type=script&lang=ts&"
export * from "./MeasureCard.vue?vue&type=script&lang=ts&"
import style0 from "./MeasureCard.vue?vue&type=style&index=0&id=13b2205d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b2205d",
  null
  
)

export default component.exports